import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { QuoteToolLiteState, SharedDataStore } from '../../../store';
import { CourseDetails, Flows } from '@lx/quote-tool/lite/shared/types';
import { RouteIds } from '../../../types';
import { ResidenceDataService } from '../../residence-data.service';
import { StepDefinitionService } from '../../step-definition.service';
import { BaseOnlineCourseModeStrategyService } from '@lx/quote-tool/lite/online/services';
import { SchoolV4 } from '@lx/shared/data-access/school';

@Injectable({
  providedIn: 'root',
})
export class OnlineCourseModeStrategyService extends BaseOnlineCourseModeStrategyService<RouteIds, CourseDetails, QuoteToolLiteState> {
  private readonly residenceDataService = inject(ResidenceDataService);
  private readonly sharedDataStore = inject(SharedDataStore);
  private readonly stepDefinitionService = inject(StepDefinitionService);

  getStepToNavigate(): Observable<RouteIds> | RouteIds {
    return of(RouteIds.course);
  }

  protected getResidenceCountryCode(): string | undefined {
    return this.residenceDataService.detectCountryCode();
  }

  protected getSchoolsObservable(): Observable<SchoolV4[]> {
    return this.sharedDataStore.schools$;
  }

  protected getCurrentStepId(): RouteIds {
    return this.stepDefinitionService.getStepDefinition(RouteIds.course, Flows.Online).id;
  }
}
